<template>
  <Breadcrumbs />
  <DynamicContent
    id="shops-content-introduction"
    class="container dynamic-content"
    :html="content?.introductionBlock"
  ></DynamicContent>

  <div class="container" :class="{ 'mb-2': !isContentBlockEmpty(content?.introductionBlock) }">
    <BaseTitle>{{ $t("shops.shops-from-a-z") }} </BaseTitle>
    <AlphabetGrid />
  </div>
  <ShopsGrid
    :input="{ searchFilter }"
    :pagination="{ limit: 20, offset: 0 }"
    :title="isContentBlockEmpty(content?.introductionBlock) ? shopsTitle : undefined"
    :show-load-more="true"
  />

  <DynamicContent
    id="shops-content-similar"
    class="container dynamic-content"
    :html="content?.similarBlock"
  ></DynamicContent>
  <DynamicContent
    id="shops-content-timed"
    class="container dynamic-content"
    :html="content?.timedBlock"
  ></DynamicContent>
  <DynamicContent
    id="shops-content-offers"
    class="container dynamic-content"
    :html="content?.offersBlock"
  ></DynamicContent>
</template>

<script setup lang="ts">
import { SearchFilter, useWebsitePageQuery } from "~/graphql/generated";

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    "nl-NL": "/winkels",
    fr: "/magasins",
    nl: "/winkels",
  },
});

const activeChar = useRouteQuery("startsWith", "", {
  transform: String,
});

const searchFilter = computed(
  () => SearchFilter[activeChar.value as keyof typeof SearchFilter],
);

const { t } = useI18n();
const shopsTitle = computed(() => {
  if (activeChar.value)
    return t("shops.shops-starting-with", [activeChar.value]);
  return t("shops.title");
});

// Set the (optional) page content blocks
const path = useRoute().path;
const { websitePagePath } = useWebsitePagePath(path);
const page = await useWebsitePageQuery({ variables: websitePagePath });
const content = useDynamicContent(page.data);
</script>

<style lang="scss" scoped></style>
